/* INK. Studio: header, menu drawer, cart count, quantity steppers */
(function () {
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const drawer = document.querySelector('[data-drawer]');
  const openBtn = document.querySelector('[data-menu-open]');
  if (drawer && openBtn) {
    const open = () => {
      drawer.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = drawer.querySelector('.drawer__nav a');
      if (first) first.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    };
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  window.INK = window.INK || {};
  window.INK.setCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    const link = document.querySelector('[data-cart-link]');
    if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
  };
  window.INK.refreshCart = function () {
    const url = (window.INK.routes && window.INK.routes.cartJs) || '/cart.js';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => { window.INK.setCartCount(cart.item_count); return cart; })
      .catch(() => null);
  };
})();
